<div class="container page page-student-registration">

  <div class="row">

    <div class="col-12">
      <div class="language-selector float-right">
        <a class="cursor-pointer" *ngFor="let language of supportedLanguages()" (click)="localeService.setLanguage(language.code)">
          <span class="img-16 mr-3">{{ language.flag }}</span>
        </a>
      </div>
    </div>

  </div>

  <div class="row">

    <div class="col-12">

      <div class="row mt-4">

        <div class="col-12 col-sm-6">

          <div class="text-intro">
            <p class="font-weight-bold">{{'Hey there' | translate}}, {{'Let\'s go!' | translate}}</p>
            <p class="font-weight-bold">{{'Create your profile and find your internship, traineeship, sidejob or job' | translate}}</p>

            <p>
              {{'Write something down about yourself so we can match you with top companies' | translate}}
            </p>
          </div>

        </div>

        <div class="col-12 col-sm-6 text-center text-md-right">

          <div class="image-wrapper">
            <img class="image-rocket" src="assets/img/illustrations/rocket-start.png" />
          </div>

        </div>

      </div>

      <ul class="nav nav-pills nav-wizard mb-4 justify-content-center">
        <li *ngFor="let step of stepWizard.steps" class="nav-item" [ngClass]="{'processed' : step.step < stepWizard.currentStep}">
          <span class="nav-link d-flex flex-row justify-content-between" [ngClass]="{'active': step.step == stepWizard.currentStep}">
            <span class="step-title">
              {{step.step}}. {{step.title | translate}}
              <fa-icon *ngIf="stepWizard.currentStep > step.step" [icon]="faCheckCircle"></fa-icon>
            </span>
            <i class="fa fa-check icon icon-valid icon-color icon-circle icon-sm"></i>
          </span>
        </li>
      </ul>

      <div class="tab-content">

        <div *ngFor="let step of stepWizard.steps;let stepKey = index;" [attr.id]="'#tab-step' + step.step" [ngClass]="{'active': step.step == stepWizard.currentStep}" class="tab-pane">

          <div id="step-1" [ngClass]="{'d-none' : stepWizard.currentStep != 1}" class="step-1">

            <h3 class="tab-title">{{'Personal details' | translate}}</h3>

            <div class="row">

              <div class="col-12">

                <div class="form-group">
                  <label>{{'First name' | translate}} *</label>
                  <input type="text" class="form-control" data-cy="firstName" name="given-name" autocomplete="given-name" [(ngModel)]="entity.firstName" />
                  <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'firstName')">
                    <p>{{'Please fill in your first name' | translate}}</p>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{'Last name' | translate}} *</label>
                  <input type="text" class="form-control" data-cy="lastName" name="family-name" autocomplete="family-name" [(ngModel)]="entity.lastName" />
                  <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'lastName')">
                    <p>{{'Please fill in your last name' | translate}}</p>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{'Phone number' | translate}} *</label>
                  <input type="tel" class="form-control" data-cy="phoneNumber" name="tel" autocomplete="tel" [(ngModel)]="entity.phoneNumber" />
                  <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'phoneNumber')">
                    <p>{{'Please fill in your phone number' | translate}}</p>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{'Birthdate' | translate}} *</label>
                  <app-input-birthdate type="text" (change)="checkAge()" [(ngModel)]="entity.birthDate"></app-input-birthdate>
                  <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'birthDate')">
                    <p>{{'Please fill in your birthdate' | translate}}</p>
                  </div>
                </div>

                <!-- parental consent -->
                <div class="parental-consent" *ngIf="showParentalConsent">

                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" [(ngModel)]="entity.hasParentalConsent" class="custom-control-input" id="hasParentalConsent">
                      <label class="custom-control-label" for="hasParentalConsent">{{'My parents give me permission to register on this website' | translate}}</label>
                    </div>

                    <div class="alert alert-info mt-2" *ngIf="showParentalConsent && entity.hasParentalConsent">
                      <i class="fa fa-info-circle mr-2"></i>
                      <small>{{'Parental consent reminder message' | translate}}</small>
                    </div>

                    <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'hasParentalConsent')">
                      <p>{{'Please give parental consent to proceed' | translate}}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>{{'Email address of your parents' | translate}} *</label>
                    <input type="email" class="form-control" autocomplete="off" [(ngModel)]="entity.parentEmailAddress" />
                    <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'parentEmailAddress')">
                      <p>{{'Please fill in the email address of your parents' | translate}}</p>
                    </div>
                  </div>

                </div>

                <div class="form-group">
                  <label>{{'What are you?' | translate}} *</label>
                  <select class="form-control" data-cy="profileType" [(ngModel)]="entity.profileType">
                    <option *ngFor="let option of profileTypeOptions" [value]="option.value">
                      {{option.name | translate}}
                    </option>
                  </select>
                  <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'profileType')">
                    <p>{{'Please fill in what you are' | translate}}</p>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{'What are you looking for?' | translate}} *</label>
                  <select class="form-control" data-cy="lookingFor" [(ngModel)]="entity.lookingFor">
                    <option *ngFor="let option of lookingForOptions" [value]="option.value">
                      {{option.name | translate}}
                    </option>
                  </select>
                  <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'lookingFor')">
                    <p>{{'Please fill in what you are looking for' | translate}}</p>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{'Reference code' | translate}} ({{'optional' | translate}})</label>
                  <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.referenceCode" />
                  <small class="text-muted">
                    {{'Only fill in if you received this code' | translate}}
                  </small>
                </div>

              </div>

            </div>

            <h3>{{'Address' | translate}}</h3>

            <div class="row">

              <div class="col-sm-12">

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'street', 'homeAddress')">
                  <p>{{'Please fill in your street name' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'number', 'homeAddress')">
                  <p>{{'Please fill in your street number' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'city', 'homeAddress')">
                  <p>{{'Please fill in your city' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'postalCode', 'homeAddress')">
                  <p>{{'Please fill in your postal code' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'country', 'homeAddress')">
                  <p>{{'Please select your country' | translate}}</p>
                </div>

                <div class="row">

                  <div class="col-sm-8">
                    <div class="form-group">
                      <label>{{'Street' | translate}} *</label>
                      <input type="text" class="form-control" data-cy="addressStreet" name="address-line1" autocomplete="address-line1" [(ngModel)]="entity.homeAddress.street" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="form-group">
                      <label>{{'No.' | translate}} *</label>
                      <input type="text" class="form-control" data-cy="addressNumber" name="address-line2" autocomplete="address-line2" [(ngModel)]="entity.homeAddress.number" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="form-group">
                      <label>{{'Addition' | translate}}</label>
                      <input type="text" class="form-control" autocomplete="off" [(ngModel)]="entity.homeAddress.numberSuffix" />
                    </div>
                  </div>

                  <div class="col-sm-8">
                    <div class="form-group">
                      <label>{{'City' | translate}} *</label>
                      <input type="text" class="form-control" data-cy="addressCity" name="city" autocomplete="address-level2" [(ngModel)]="entity.homeAddress.city" />
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>{{'Postal code' | translate}} *</label>
                      <input type="text" class="form-control" data-cy="addressPostalCode" name="postal-code" autocomplete="postal-code" [(ngModel)]="entity.homeAddress.postalCode" />
                    </div>
                  </div>

                </div>

                <div class="form-group">
                  <label>{{'Country' | translate}} *</label>
                  <select class="form-control" data-cy="addressCountry" name="country" autocomplete="country" [(ngModel)]="entity.homeAddress.country">
                    <option *ngFor="let option of locale.prioritizedCountries()" [value]="option.code">{{option.name}}</option>
                  </select>
                </div>

              </div>
            </div>

          </div>

          <div id="step-2" [ngClass]="{'d-none' : stepWizard.currentStep != 2}" class="step-2">

            <h3 class="tab-title">{{'Education' | translate}}</h3>

            <div class="education-form">

              <div class="entity-education">

                <div class="row">

                  <div class="col-12 col-sm-6">

                    <!-- education level -->
                    <div class="form-group">
                      <label>{{'Education level' | translate}} *</label>
                      <select class="form-control" data-cy="educationLevel" [(ngModel)]="education.educationLevelId" (change)="setEducationLevelOptions()">
                        <option *ngFor="let level of educationLevels" [value]="level.id">
                          {{level.name}}
                        </option>
                      </select>
                      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 2, 'education', 'educationLevelId')">
                        <p>{{'Please fill in education level' | translate}}</p>
                      </div>
                    </div>

                    <!-- education profile -->
                    <div class="form-group" *ngIf="profileOptions.length > 0">
                      <label>{{'Profile' | translate}}</label>
                      <select class="form-control" data-cy="educationProfile" [(ngModel)]="education.educationProfileId">
                        <option *ngFor="let profile of profileOptions" [value]="profile.id">
                          {{profile.name | translate}}
                        </option>
                      </select>
                    </div>

                    <!-- education program new -->
                    <div class="form-group">
                      <label>{{'Education name' | translate}} *</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <fa-icon [icon]="faGraduationCap"></fa-icon>
                          </span>
                        </div>
                        <span app-typeahead-educationprogram [(ngModel)]="education.programName" [selectorName]="'title'" [selectorValue]="'title'" (selectEvent)="handleEducationProgramSelection($event)"></span>
                      </div>
                      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 2, 'education', 'programName')">
                        <p>{{'Please fill in education name' | translate}}</p>
                      </div>
                    </div>

                    <!-- phase -->
                    <div class="form-group" *ngIf="phaseOptions.length > 0" [ngClass]="{'d-none': education.graduated}">
                      <label>{{'Phase' | translate}}</label>
                      <select class="form-control" [(ngModel)]="education.phase">
                        <option *ngFor="let phase of phaseOptions" [value]="phase">
                          {{phase | translate}}
                        </option>
                      </select>
                    </div>

                    <!-- graduated -->
                    <div class="form-group">
                      <div class="custom-control custom-checkbox">
                        <input id="graduated" class="custom-control-input" type="checkbox" [(ngModel)]="education.graduated" />
                        <label for="graduated" class="custom-control-label">{{'Graduated' | translate}}</label>
                      </div>
                    </div>

                    <!-- current -->
                    <div class="form-group">
                      <div class="custom-control custom-checkbox">
                        <input id="isCurrent" class="custom-control-input" type="checkbox" [(ngModel)]="education.isCurrent" />
                        <label for="isCurrent" class="custom-control-label">{{'Current education' | translate}}</label>
                      </div>
                    </div>

                  </div>

                  <div class="col-12 col-sm-6">

                    <div class="form-group">
                      <label>{{'Name school' | translate}} *</label>
                      <input type="text" class="form-control" data-cy="schoolName" [(ngModel)]="education.schoolName" />
                      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 2, 'education', 'schoolName')">
                        <p>{{'Please fill in school name' | translate}}</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{'City school' | translate}} *</label>
                      <input type="text" class="form-control" data-cy="schoolCity" [(ngModel)]="education.schoolCity" />
                      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 2, 'education', 'schoolCity')">
                        <p>{{'Please fill in school city' | translate}}</p>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{'Country school' | translate}} *</label>
                      <select class="form-control" data-cy="schoolCountry" [(ngModel)]="education.schoolCountry">
                        <option *ngFor="let level of locale.availableCountries()" [value]="level.code">
                          {{level.name}}
                        </option>
                      </select>
                      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 2,'education', 'schoolCountry')">
                        <p>{{'Please fill in school country' | translate}}</p>
                      </div>
                    </div>

                  </div>

                </div>

                <!-- extras -->
                <div class="form-group">
                  <label>{{'Courses / minors / electives' | translate}}</label>
                  <textarea rows="5" class="form-control" [(ngModel)]="education.extras"></textarea>
                </div>

                <!-- period -->
                <div class="form-group row">
                  <label class="col-12 col-sm-12 col-form-label">{{'Period (from / till)' | translate}} *</label>
                  <div class="col-12 col-sm-6">
                    <input ngbDatepicker [minDate]="longMinDate" data-cy="educationPeriodFrom" class="form-control" [(ngModel)]="education.startDate" (click)="startdate.toggle()" #startdate="ngbDatepicker" />
                    <div class="alert alert-danger validation-error" *ngIf="showValidationError( 2, 'education', 'startDate')">
                      <p>{{'Please fill in start date' | translate}}</p>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <input ngbDatepicker [minDate]="longMinDate" data-cy="educationPeriodUntil" class="form-control" [(ngModel)]="education.endDate" (click)="enddate.toggle()" #enddate="ngbDatepicker" />
                  </div>
                </div>

                <!-- area of interests -->
                <div class="interests">

                  <h3>{{'Field of interest' | translate}} *</h3>

                  <app-selector-areaofinterests [maxAmount]="maxAmount" [(ngModel)]="entity.areaOfInterests"></app-selector-areaofinterests>

                </div>

              </div>

            </div>

          </div>


          <div id="step-3" [ngClass]="{'d-none' : stepWizard.currentStep != 3}" class="step-3">

            <h3 class="tab-title">{{'Make your profile complete' | translate}}</h3>

            <p class="text-muted mb-4">{{'A stronger profile leads to better matches. All fields are optional — you can always add more in your profile.' | translate}}</p>

<!-- Success strip after an AI import -->
<div *ngIf="cvImport.completed" class="alert alert-success d-flex align-items-center mb-4">
  <span>
    {{ 'Imported' | translate }}:
    {{ cvImport.importedCounts.workExperience }} {{ 'work experience(s)' | translate }},
    {{ cvImport.importedCounts.languages }} {{ 'language(s)' | translate }}
  </span>
</div>

<!-- CV upload + AI import field -->
<form [formGroup]="cvUploadForm" class="mb-4">
  <formly-form [form]="cvUploadForm" [fields]="cvUploadFields" [model]="cvUploadModel"></formly-form>
</form>

            <!-- Werkervaring -->
<div class="mb-4 p-3 border rounded">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="mb-0">
      <fa-icon [icon]="faBriefcase" class="mr-2 text-muted"></fa-icon>
      {{'Work experience' | translate}}
    </h5>
    <small class="text-muted">{{cv.workExperiences.length}} {{'added' | translate}}</small>
  </div>
  <p class="text-muted small mb-2" *ngIf="cv.workExperiences.length === 0">
    {{'No work experience added yet' | translate}}
  </p>
  <ul class="list-unstyled mb-2" *ngIf="cv.workExperiences.length > 0">
    <li *ngFor="let item of cv.workExperiences" class="d-flex justify-content-between align-items-center px-3 py-2 mb-1 bg-light rounded">
      <span>{{item.jobTitle}} <span class="text-muted">· {{item.companyName}}</span></span>
      <a class="text-muted cursor-pointer" role="button" tabindex="0" aria-label="Remove work experience" (click)="removeWorkExperience(item.id)" (keydown.enter)="removeWorkExperience(item.id)" (keydown.space)="removeWorkExperience(item.id); $event.preventDefault()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </a>
    </li>
  </ul>
  <button type="button" class="btn btn-outline-primary btn-sm" (click)="openWorkExperienceModal()">
    <fa-icon [icon]="faPlus" class="mr-1"></fa-icon> {{'Add work experience' | translate}}
  </button>
</div>

<!-- Talen -->
<div class="mb-4 p-3 border rounded">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="mb-0">
      <fa-icon [icon]="faGlobe" class="mr-2 text-muted"></fa-icon>
      {{'Languages' | translate}}
    </h5>
    <small class="text-muted">{{cv.languages.length}} {{'added' | translate}}</small>
  </div>
  <p class="text-muted small mb-2" *ngIf="cv.languages.length === 0">
    {{'No languages added yet' | translate}}
  </p>
  <ul class="list-unstyled mb-2" *ngIf="cv.languages.length > 0">
    <li *ngFor="let item of cv.languages" class="d-flex justify-content-between align-items-center px-3 py-2 mb-1 bg-light rounded">
      <span>{{item.languageCode}} <span class="text-muted" *ngIf="item.speakingProficiency !== undefined">· {{getLanguageLevelName(item.speakingProficiency)}}</span></span>
      <a class="text-muted cursor-pointer" role="button" tabindex="0" aria-label="Remove language" (click)="removeLanguage(item.id)" (keydown.enter)="removeLanguage(item.id)" (keydown.space)="removeLanguage(item.id); $event.preventDefault()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </a>
    </li>
  </ul>
  <button type="button" class="btn btn-outline-primary btn-sm" (click)="openLanguageModal()">
    <fa-icon [icon]="faPlus" class="mr-1"></fa-icon> {{'Add language' | translate}}
  </button>
</div>

<!-- Buitenland-ervaring -->
<div class="mb-4 p-3 border rounded">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="mb-0">
      <fa-icon [icon]="faPlane" class="mr-2 text-muted"></fa-icon>
      {{'Foreign experience' | translate}}
    </h5>
    <small class="text-muted">{{cv.foreignExperiences.length}} {{'added' | translate}}</small>
  </div>
  <p class="text-muted small mb-2" *ngIf="cv.foreignExperiences.length === 0">
    {{'No foreign experience added yet' | translate}}
  </p>
  <ul class="list-unstyled mb-2" *ngIf="cv.foreignExperiences.length > 0">
    <li *ngFor="let item of cv.foreignExperiences" class="d-flex justify-content-between align-items-center px-3 py-2 mb-1 bg-light rounded">
      <span>{{item.country}} <span class="text-muted">· {{item.description}}</span></span>
      <a class="text-muted cursor-pointer" role="button" tabindex="0" aria-label="Remove foreign experience" (click)="removeForeignExperience(item.id)" (keydown.enter)="removeForeignExperience(item.id)" (keydown.space)="removeForeignExperience(item.id); $event.preventDefault()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </a>
    </li>
  </ul>
  <button type="button" class="btn btn-outline-primary btn-sm" (click)="openForeignExperienceModal()">
    <fa-icon [icon]="faPlus" class="mr-1"></fa-icon> {{'Add foreign experience' | translate}}
  </button>
</div>

<!-- Hobby's -->
<div class="mb-4 p-3 border rounded">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="mb-0">
      <fa-icon [icon]="faStar" class="mr-2 text-muted"></fa-icon>
      {{'Hobbies & interests' | translate}}
    </h5>
    <small class="text-muted">{{cv.hobbies.length}} {{'added' | translate}}</small>
  </div>
  <p class="text-muted small mb-2" *ngIf="cv.hobbies.length === 0">
    {{'No hobbies added yet' | translate}}
  </p>
  <ul class="list-unstyled mb-2" *ngIf="cv.hobbies.length > 0">
    <li *ngFor="let item of cv.hobbies" class="d-flex justify-content-between align-items-center px-3 py-2 mb-1 bg-light rounded">
      <span>{{item.description}}</span>
      <a class="text-muted cursor-pointer" role="button" tabindex="0" aria-label="Remove hobby" (click)="removeHobby(item.id)" (keydown.enter)="removeHobby(item.id)" (keydown.space)="removeHobby(item.id); $event.preventDefault()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </a>
    </li>
  </ul>
  <button type="button" class="btn btn-outline-primary btn-sm" (click)="openHobbyModal()">
    <fa-icon [icon]="faPlus" class="mr-1"></fa-icon> {{'Add hobby' | translate}}
  </button>
</div>

          </div>


          <div id="step-4" [ngClass]="{'d-none' : stepWizard.currentStep != 4}" class="step-4 step-final text-center">

            <h3 class="tab-title">{{'Match' | translate}}</h3>

            <p>{{'You filled in the most important information, now it is time to match!' | translate}}</p>

            <p>{{'Press the button to match with your dream companies.' | translate}}</p>

            <button class="btn btn-primary btn-lg ml-auto mr-auto" data-cy="match" (click)="Match()">
              {{'Match' | translate}}
            </button>

          </div>

        </div>

        <div class="setup-controls btn-toolbar d-flex flex-grow-1 align-items-stretch justify-content-between mb-3">

          <button class="btn btn-outline-secondary" (click)="previousStep()" *ngIf="stepWizard.currentStep > 1 && stepWizard.currentStep !== stepWizard.steps.length">
            <i class="fa fa-arrow-left"></i> {{'Previous' | translate}}
          </button>

          <button class="btn btn-link text-muted ml-auto mr-2" *ngIf="stepWizard.currentStep === 3" (click)="skipCvStep()">
            {{'Skip' | translate}}
          </button>

          <button class="btn btn-outline-primary" [ngClass]="{'ml-auto': stepWizard.currentStep !== 3}" *ngIf="stepWizard.currentStep !== stepWizard.steps.length" data-cy="nextStep" (click)="nextStep()">
            {{'Next' | translate}} <i class="fa fa-arrow-right"></i>
          </button>

        </div>

      </div>

    </div>

  </div>

</div>
